import { render, staticRenderFns } from "./DashTech.vue?vue&type=template&id=209c0ea7&"
import script from "./DashTech.vue?vue&type=script&lang=ts&"
export * from "./DashTech.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports